let config: Config = require("../config.default.json");
try {
    const localConfig = require("../config.local.json");
    config = Object.assign(config, localConfig);
} catch (e) {
    // Do nothing
}

export default config;

interface Config {
    debug: boolean;
    debugPeer?: boolean;
    debugRedux?: boolean;
    debugBuzzer?: boolean;
    debugFullScreen?: boolean;
    ssUrl: string;
    sessionOverRedirectUrl: string;
    autoShowBuzzer?: boolean;
}
